import React from "react";
import { createPortal } from "react-dom";
import channelLauncherImg from "assets/images/icons/channel-launcher.png";
import {
  DEFAULT_LAUNCHER_BOTTOM,
  useChannelTalkLauncherPosition,
  useChannelTalkMessengerOpen,
} from "hooks/useChannelTalkLauncherPosition";
import useWindowSize, { Size } from "hooks/useWindowSize";
import * as S from "./style";

function ChannelTalkLauncher() {
  const bottom = useChannelTalkLauncherPosition();
  const { isMessengerOpen, openMessenger, isMobileMenuOpen } =
    useChannelTalkMessengerOpen();
  const size: Size = useWindowSize();
  const isMobile = size.width && size.width <= 1023;
  const hideLauncher =
    isMessengerOpen || Boolean(isMobile && isMobileMenuOpen);

  if (typeof document === "undefined" || hideLauncher) {
    return null;
  }

  return createPortal(
    <S.LauncherButton
      type="button"
      aria-label="문의하기"
      style={
        bottom > DEFAULT_LAUNCHER_BOTTOM
          ? { bottom: `${bottom}px` }
          : undefined
      }
      onClick={openMessenger}
    >
      <S.LauncherImage
        src={channelLauncherImg}
        alt=""
        draggable={false}
      />
    </S.LauncherButton>,
    document.body
  );
}

export default ChannelTalkLauncher;
